import { render, staticRenderFns } from "./Template2.vue?vue&type=template&id=2dc3ee28"
import script from "./Template2.vue?vue&type=script&lang=js"
export * from "./Template2.vue?vue&type=script&lang=js"
import style0 from "./Template2.vue?vue&type=style&index=0&id=2dc3ee28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports